<template>
  <div class="p-4">
    <p class="font-italic mb-4">
      {{ text }}
    </p>
    <div class="input-group mb-4 border rounded-pill p-2">
      <input
        type="text"
        placeholder="Apply coupon"
        aria-describedby="button-addon3"
        class="form-control border-0"
      />
      <div class="input-group-append border-0">
        <button
          id="button-addon3"
          type="button"
          class="btn btn-dark px-4 rounded-pill"
        >
          <font-awesome-icon :icon="['fas', 'gift']" class="mr-2" />Apply coupon
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CartCoupon",
  props: {
    text: {
      type: String,
      default: "If you have a coupon code, please enter it in the box below"
    }
  }
};
</script>
